export default {
  baseURL: process.env.VUE_APP_BASE_URL,
  authURL: process.env.VUE_APP_AUTH_URL,
  logoutURL: process.env.VUE_APP_LOGOUT_URL,
  redirectURI: process.env.VUE_APP_REDIRECT_URI,
  clientID: process.env.VUE_APP_CLIENT_ID,
  oftURL: process.env.VUE_APP_OFT_URL,
  analyzerURL: process.env.VUE_APP_ANALYZER_URL,
};
